import React from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { graphql } from "gatsby";
import Hero from "../components/Hero";
import SectionDivider from "../components/SectionDivider";
import Servicios from "../components/Servicios";
import Viajes from "../components/Viajes";
import Promociones from "../components/Promociones";
import ContactForm from "../components/ContactForm";
import CTAComponent from "../components/CTAComponent";

const IndexPage = ({ data }) => {
  // allStrapiPromos object with the name of node: promos
  const {
    allStrapiPromocions: { nodes: promocions },
  } = data;

  return (
    <>
      <GatsbySeo
        title="Viajes Omega"
        description="Omega agencia de viajes, viajes a todos los destinos con lo mejores precios"
        canonical="https://omega-agencia.netlify.app"
        metaTags={[
          {
            property: "og:url",
            content: "https://omega-agencia.netlify.app/",
          },
          {
            property: "og:title",
            content: "Viajes Omega",
          },
        ]}
      />
      <Hero />
      <SectionDivider />
      <Servicios />
      <Viajes />
      <Promociones
        showLink
        title="Nuestras Promociones"
        promocions={promocions}
      />
      <CTAComponent />
      <ContactForm />
    </>
  );
};

export const query = graphql`
  {
    allStrapiPromocions(filter: { featured: { eq: true } }) {
      nodes {
        Titulo
        descripcion
        featured
        slug
        banner {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: TRACED_SVG, layout: FULL_WIDTH)
            }
          }
        }
        imagen {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: TRACED_SVG, layout: FULL_WIDTH)
            }
          }
        }
      }
      totalCount
    }
  }
`;

export default IndexPage;
